import { render, staticRenderFns } from "./MasterDepartmentDetail.vue?vue&type=template&id=579c93c0&"
import script from "./MasterDepartmentDetail.vue?vue&type=script&lang=js&"
export * from "./MasterDepartmentDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports